import { generateCaptchaSolution } from '../../helpers/captchas';
export const CAPTCHA_FALLBACK_SOLUTION = 'UNABLE TO GENERATE CAPTCHA SOLUTION';
export const solveCaptcha = async () => {
    try {
        return await generateCaptchaSolution();
    }
    catch (e) {
        return CAPTCHA_FALLBACK_SOLUTION;
    }
};
export class CaptchaSolver {
    pending = null;
    start() {
        if (!this.pending) {
            this.pending = solveCaptcha();
        }
    }
    take() {
        this.start();
        const solution = this.pending;
        this.pending = null;
        return solution;
    }
}
